import React from 'react';
import Select from "react-dropdown-select";

export const InputDropdown = ({question, setState, hidden, setIsInputFilled, required, default_value, override_label})  => {
    return (
        <div className={"my-2 " + hidden}>
            <label htmlFor="q1a" className="block my-1 text-sm font-medium text-gray-900">
                {override_label || question?.label || question?.info}
                {required ? '*' : null}
            </label>

            <Select
                options={question?.options || []}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm !rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full py-3 px-3"
                required={required}
                placeholder={(default_value && default_value.length > 0) ? default_value : 'Select...'}
                onChange={(values) => {
                    setState(values[0]?.label);
                    if (setIsInputFilled) setIsInputFilled(true);
                }}
            />
        </div>
    );
};